import { ThreeDots } from "react-loader-spinner";
import Pagination from "../../../assets/SharedComponents/Pagination";
import NoRecord from "../../../assets/SharedComponents/Table/NoRecord";
import { FaFilterIcon } from "../../../assets/Images/icon";
import { Tooltip } from "@mui/material";
import { AuctionReservationWrapper } from "./Style";
import { useEffect, useState } from "react";
import { APP_URLS } from "../../../api/url";
import API from "../../../api/axios";
import { toast } from "react-toastify";
import { APIError, formatCurrency, showUserTypeBadge } from "../../../core/utils";
import { HOLD_DEPOSIT_STATUS, HOLD_DEPOSIT_STATUS_INVERSE } from "../../../config/constant";
import StaticFilter from "../../../assets/SharedComponents/Filters/StaticFilter";
import moment from "moment";
import RecordCount from "../../../assets/SharedComponents/RecordCount/RecordCount";

const holdDepositStatuses = Object.keys(HOLD_DEPOSIT_STATUS).map((key) => ({
  name: HOLD_DEPOSIT_STATUS_INVERSE[HOLD_DEPOSIT_STATUS[key]],
  value: HOLD_DEPOSIT_STATUS[key],
}));

const DaysOfNoActionOptions = [
  { name: '7 days', value: 7 },
  { name: '15 days', value: 15 },
  { name: '1 Month', value: 30 },
]

const OnHoldDeposits = () => {

  const [deposits, _deposits] = useState({
    data: [],
    loading: false,
    currentPage: 1,
    totalPages: 1,
    recordCount: 0
  })

  const [filters, _filters] = useState({
    no_action_days: 7,
    per_page: 10,
    status: ''
  })

  useEffect(() => {
    _deposits((prev) => {
      return {
        ...prev,
        loading: true
      }
    })
    const getDeposits = () => {
      const params = new URLSearchParams({
        page: deposits.currentPage.toString(),
        per_page: filters.per_page.toString(),
      });

      if (filters.no_action_days) {
        params.append("no_action_days", filters.no_action_days.toString());
      }

      if (filters.status) {
        params.append("status", filters.status);
      }

      API.get(`${APP_URLS.LIST_ON_HOLD_DEPOSIT}?${params.toString()}`)
        .then((res) => {
          const resp = res.data;
          if (resp.success === true) {
            _deposits((prev) => ({
              ...prev,
              data: resp.data.data,
              currentPage: resp.data.current_page,
              totalPages: resp.data.last_page,
              recordCount: resp.data.total,
            }));
          } else {
            toast.error(resp.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch((error) => {
          let error_message = APIError(error);
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        })
        .finally(() => {
          _deposits((prev) => ({
            ...prev,
            loading: false,
          }));
        });
    };
    getDeposits()
  }, [deposits.currentPage, filters.no_action_days, filters.per_page, filters.status])

  const handleFilterChange = (key, value) => {
    _filters((prev) => {
      return {
        ...prev,
        [key]: value
      }
    })
    _deposits((prev) => {
      return {
        ...prev,
        currentPage: 1,
        data: []
      }
    })
  }

  const clearFilter = () => {
    _filters({
      no_action_days: 7,
      per_page: 10,
      status: ''
    })
    _deposits((prev) => {
      return {
        ...prev,
        currentPage: 1
      }
    })
  }



  return (
    <AuctionReservationWrapper>
      <div className="auctionMainContainer">
        <div className="row mt-4">
          <div className="col-md-12 text-align-center">
            <h1>On Hold Deposits</h1>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between info-wrap mt-3 mb-2">
          <div className="justify-content-end mt-1 me-2">
            <span>Total Records : <b>{deposits.recordCount}</b></span>
          </div>
          <div className="justify-content-end mt-4 d-flex gap-2 mb-2 select-info align-items-center">
            <StaticFilter
              placeholder="Status"
              data={holdDepositStatuses}
              handleChange={(e) => {
                handleFilterChange('status', e.target.value);
              }}
              value={filters.status}
            />
            <StaticFilter
              placeholder="Days of no action"
              data={DaysOfNoActionOptions}
              handleChange={(e) => {
                handleFilterChange('no_action_days', e.target.value);
              }}
              value={filters.no_action_days}
            />
            <RecordCount
              onSearchClick={(search) => handleFilterChange('per_page', search)}
              id="pageCount"
              val={filters.per_page}
              key={filters.per_page}
            />
            <Tooltip title="Clear Filter" placement="bottom">
              <FaFilterIcon className="filter-icon" role="button" onClick={clearFilter} />
            </Tooltip>
          </div>
        </div>

        <div className="tableContainer">
          <table className="auctionTable">
            <thead className="tableHead">
              <tr className="table-row">
                <th>Ad</th>
                <th>
                  <p>Auction</p>
                  <p>Start</p>
                  <p>End</p>
                </th>
                <th>Bid amount</th>
                <th>Bid placed at</th>
                <th>Buyer</th>
                <th>Seller</th>
                <th>Status</th>
              </tr>
            </thead>

            {deposits.loading ? (
              <div className="d-flex justify-content-center three-dot">
                <ThreeDots height="150" width="150" radius="9" color="#637df4" />
              </div>
            ) : (
              <tbody>
                {deposits.data.length > 0 ? (
                  deposits.data.map((deposit) => (
                    <tr
                      key={deposit.id}
                      className={(deposit.deleted_at ? "deletedRow " : "") + "table-row"}
                    >
                      <td>
                        <span
                          onClick={() =>
                            window.open(
                              `${process.env.REACT_APP_FRONTOFFICE_URL_HTTPS}/fr/auction-ads/${deposit.ad_slug}`,
                              "_blank"
                            )
                          }
                          className="navigationLink"
                        >
                          {deposit.owner_vehicle_fulltitle}
                        </span>
                      </td>
                      <td>
                        <p>{deposit.auction.auction_event_title}</p>
                        <p>
                          {moment(deposit.auction.start)
                            .tz("Europe/Amsterdam")
                            .format("DD-MM-YYYY HH:mm")
                          }
                        </p>
                        <p>
                          {moment(deposit.auction.end)
                            .tz("Europe/Amsterdam")
                            .format("DD-MM-YYYY HH:mm")
                          }
                        </p>
                      </td>
                      <td> {formatCurrency(deposit.bid_amount ?? 0)}</td>
                      <td>
                        {moment(deposit.bid_placed_at)
                          .tz("Europe/Amsterdam")
                          .format("DD-MM-YYYY HH:mm")
                        }
                      </td>
                      <td>
                        <a
                          href={`${deposit.buyer.source === "subsidiary"
                            ? "/company-details"
                            : "/detail-member"
                            }/${deposit.buyer.id}`}
                          className="link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <b>
                            {deposit.buyer.name}
                            {showUserTypeBadge(deposit.buyer.source)}
                          </b>
                        </a>
                      </td>
                      <td>
                        <a
                          href={`${deposit.seller.source === "subsidiary"
                            ? "/company-details"
                            : "/detail-member"
                            }/${deposit.seller.id}`}
                          className="link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <b>
                            {deposit.seller.name}
                            {showUserTypeBadge(deposit.seller.source)}
                          </b>
                        </a>
                      </td>
                      <td>{HOLD_DEPOSIT_STATUS_INVERSE[deposit.status]}</td>
                    </tr>
                  ))
                ) : (
                  <NoRecord />
                )}
              </tbody>
            )}
          </table>
        </div>

        {deposits.totalPages > 1 &&
          <Pagination
            totalPages={deposits.totalPages}
            page={deposits.currentPage}
            key={deposits.totalPages}
            onPageClick={(page) => {
              _deposits((prev) => {
                return { ...prev, currentPage: page + 1 }
              })
            }}
          />
        }
      </div>
    </AuctionReservationWrapper>
  );
};

export default OnHoldDeposits;
